var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7099 5.66578L9.81678 9.89805C9.38918 10.2706 8.71332 9.96934 8.71332 9.38939V6.95143C4.40094 7.01305 2.54266 8.09142 3.8032 12.1528C3.94307 12.6035 3.40257 12.9528 3.02307 12.6744C1.80674 11.7831 0.706055 10.0801 0.706055 8.35751C0.706055 4.09443 4.24803 3.19251 8.71304 3.1393V0.899076C8.71304 0.320114 9.38807 0.0178887 9.8165 0.390418L14.7097 4.62269C15.0185 4.91512 15.0185 5.39688 14.7099 5.66578Z",
    fill: "#69757A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.7264e99a0af63c162adcd5a1891602ff.svg";
export { ForwardRef as ReactComponent };